import { createContext, useContext } from 'react';

export interface ReportBugContextValue {
  open: () => void;
  close: () => void;
  isOpen: boolean;
}

export const ReportBugContext = createContext<ReportBugContextValue | null>(null);

export const useReportBug = (): ReportBugContextValue => {
  const context = useContext(ReportBugContext);
  if (!context) {
    throw new Error('useReportBug must be used within a BugReportProvider');
  }
  return context;
};
